import { useMutation } from "@tanstack/react-query";
import { deleteDevice } from "@/shared/requests/device";

export function useDeleteDevice() {
  const mutationFn = async (device_id: string) => {
    return deleteDevice({ device_id });
  };
  return useMutation(mutationFn);
}
